import React from 'react';
import Button from '@components-clean/core/button';
import Card from '@components-clean/core/card';
import DraggableDialog from '@components-clean/core/draggable-dialog';
import { InfoField } from '@components-clean/core/info-field';
import { useBoolean } from '@hooks/index';

const InfoFieldPage = () => {
    const isInfoDialogOpened = useBoolean(false);
    const isWarningDialogOpened = useBoolean(false);
    const isErrorDialogOpened = useBoolean(false);

    const longMessage =
        // eslint-disable-next-line max-len
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';

    const shortMessage = 'Lorem ipsum dolor';

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingBottom: '10px' }}>
            <div style={{ display: 'flex', gap: '10px' }}>
                <div>
                    <h3>Info</h3>
                    <div style={{ width: '350px' }}>
                        <InfoField type="Info" message="Custom message" />
                    </div>
                </div>
                <div>
                    <h3>Warning</h3>
                    <div style={{ width: '350px' }}>
                        <InfoField type="Warning" message="Custom message" />
                    </div>
                </div>
                <div>
                    <h3>Error</h3>
                    <div style={{ width: '350px' }}>
                        <InfoField type="Error" message="Custom message" />
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
                <div>
                    <h3>Info - Variant</h3>
                    <div style={{ height: '40px', width: '180px' }}>
                        <InfoField type="Info" message="Custom message" />
                    </div>
                </div>
                <div>
                    <h3>Warning - Variant</h3>
                    <div style={{ height: '40px', width: '180px' }}>
                        <InfoField type="Warning" message="Custom message" />
                    </div>
                </div>
                <div>
                    <h3>Error - Variant</h3>
                    <div style={{ height: '40px', width: '180px' }}>
                        <InfoField type="Error" message="Custom message" />
                    </div>
                </div>
            </div>

            <div style={{ display: 'flex', gap: '10px' }}>
                <div>
                    <h3>Large text truncated</h3>
                    <div style={{ width: '350px' }}>
                        <InfoField type="Info" message={longMessage} truncated />
                    </div>
                </div>

                <div>
                    <h3>Large text wrapped</h3>
                    <div style={{ width: '350px' }}>
                        <InfoField type="Info" message={longMessage} />
                    </div>
                </div>

                <div>
                    <h3>Formatted Text</h3>
                    <div style={{ width: '350px' }}>
                        <InfoField
                            type="Info"
                            message={
                                <>
                                    Some text in <b>bold</b> and <i>italic</i>
                                </>
                            }
                        />
                    </div>
                </div>
            </div>

            <Card data-testid="info-card" title="Info field in card">
                <div style={{ height: '250px' }}>
                    <InfoField type="Info" message={longMessage} layout="center" />
                </div>
            </Card>

            <Card data-testid="warning-card" title="Warning field in card - short message">
                <div style={{ height: '250px' }}>
                    <InfoField type="Info" message={shortMessage} layout="center" />
                </div>
            </Card>

            <div>
                <Button onClick={isInfoDialogOpened.toggle} data-testid="toggle-info-dialog-truncated-button" primary>
                    Open Dialog with Info truncated
                </Button>
                {isInfoDialogOpened.value && (
                    <DraggableDialog
                        title="Dialog with Info truncated"
                        dataTestId="info-dialog-truncated"
                        onClose={() => isInfoDialogOpened.setFalse()}
                        onSubmit={() => isInfoDialogOpened.setFalse()}
                    >
                        <div className="k-h-full k-d-flex k-flex-column k-w-full">
                            <InfoField type="Info" message={longMessage} truncated />
                            <span className="k-align-self-center k-py-5">{longMessage}</span>
                        </div>
                    </DraggableDialog>
                )}
            </div>

            <div>
                <Button
                    onClick={isWarningDialogOpened.toggle}
                    data-testid="toggle-warning-dialog-wrapped-button"
                    primary
                >
                    Open Dialog with Warning wrapped
                </Button>
                {isWarningDialogOpened.value && (
                    <DraggableDialog
                        title="Dialog with Warning wrapped"
                        dataTestId="warning-dialog-wrapped"
                        onClose={() => isWarningDialogOpened.setFalse()}
                        onSubmit={() => isWarningDialogOpened.setFalse()}
                    >
                        <div className="k-h-full k-d-flex k-flex-column">
                            <InfoField type="Warning" message={longMessage} />
                            <span className="k-align-self-center k-py-5">{longMessage}</span>
                        </div>
                    </DraggableDialog>
                )}
            </div>

            <div>
                <Button onClick={isErrorDialogOpened.toggle} data-testid="toggle-error-dialog-short-button" primary>
                    Open Dialog with Error short message
                </Button>
                {isErrorDialogOpened.value && (
                    <DraggableDialog
                        title="Dialog with Error short message"
                        dataTestId="info-dialog-short"
                        onClose={() => isErrorDialogOpened.setFalse()}
                        onSubmit={() => isErrorDialogOpened.setFalse()}
                    >
                        <div className="k-h-full k-d-flex k-flex-column k-w-full">
                            <InfoField type="Error" message={shortMessage} />
                            <span className="k-align-self-center k-py-5">{longMessage}</span>
                        </div>
                    </DraggableDialog>
                )}
            </div>
        </div>
    );
};

export default InfoFieldPage;
